import Vue from 'vue'
Vue.filter('datetime', function (value,conStr) {
  // 返回处理后的值
  let currentDate = new Date(value || (new Date().getTime()))
  return currentDate.getFullYear() + conStr + (currentDate.getMonth()+1 < 10 ? '0'+(currentDate.getMonth()+1) : currentDate.getMonth()+1) + conStr + (currentDate.getDate() < 10 ? '0' + currentDate.getDate() : currentDate.getDate());
});
Vue.filter('imgUrl', function (value) {
  if(!value){
    return ''
  }else{
    return value
  }
})



// WEBPACK FOOTER //
// ./src/components/filter.js